import { Auth } from "@aws-amplify/auth"
import { FunctionComponent, useState } from "react"
import { Alert, Col, Container, Form, Row } from "react-bootstrap"
import Button from "react-bootstrap/Button"
import { useNavigate } from "react-router-dom"
import { ConfigScriptTemplate, Property } from "../data/models"
import useQuery from "../hooks/useQuery"

interface IScriptsPage {}
const ScriptsPage: FunctionComponent<IScriptsPage> = () => {
	const navigate = useNavigate()
	const [property, setProperty] = useState<Property>()
	const [template, setTemplate] = useState<ConfigScriptTemplate>()
	const propertiesQuery = useQuery<void, PropertiesOutput>(process.env.REACT_APP_KNIT_URL + "properties")
	const templatesQuery = useQuery<void, TemplatesOutput>(process.env.REACT_APP_KNIT_URL + "config-script-templates")
	//
	const setPropertyId = (id: string) => {
		setProperty(propertiesQuery.data?.properties?.find((p) => p.id === Number(id)))
	}
	const setTemplateId = (id: string) => {
		setTemplate(templatesQuery.data?.configScriptTemplates?.find((t) => t.id === id))
	}
	const download = async () => {
		const session = await Auth.currentSession()
		const urlString = `${process.env.REACT_APP_KNIT_URL}config-scripts?propertyId=${property?.id}&templateId=${template?.id}`
		const headers = {
			Authorization: session.getIdToken().getJwtToken(),
			Accept: "application/zip",
		}
		const response = await fetch(urlString, { headers, method: "GET" })
		if (response.status !== 200) throw Error("Error downloading")
		const blob = await response.blob()
		//this is a weird hacky solution for downloads, but it works
		const url = window.URL.createObjectURL(blob)
		const a = document.createElement("a")
		document.body.appendChild(a)
		;(a as any).style = "display: none"
		a.href = url
		a.download = `${property?.name}-${template?.name}.zip`
		a.click()
		window.URL.revokeObjectURL(url)
	}
	//
	const loading = !propertiesQuery.data || propertiesQuery.loading || !templatesQuery.data || templatesQuery.loading
	const error = propertiesQuery.error || templatesQuery.error
	//
	if (loading) {
		return (
			<Container style={{ maxWidth: 500 }}>
				<h2 className="text-center mt-4">Download Scripts</h2>
				<div className="text-center">Loading</div>
			</Container>
		)
	}
	return (
		<Container style={{ maxWidth: 500 }}>
			<h2 className="text-center mt-4">Download Scripts</h2>
			{error && <Alert variant={"warning"}>{error}</Alert>}
			<Row className="mt-4">
				<Form.Group className="mb-3" controlId="property">
					<Form.Label>Property</Form.Label>
					<Form.Select required value={property?.id} onChange={(e) => setPropertyId(e.target.value)}>
						<option></option>
						{propertiesQuery.data?.properties?.map((p) => (
							<option key={p.id} value={p.id}>
								{p.name}
							</option>
						))}
					</Form.Select>
				</Form.Group>
				<Form.Group className="mb-3" controlId="template">
					<Form.Label>Template</Form.Label>
					<Form.Select required value={template?.id} onChange={(e) => setTemplateId(e.target.value)}>
						<option></option>
						{templatesQuery.data?.configScriptTemplates?.map((t) => (
							<option key={t.id} value={t.id}>
								{t.name}
							</option>
						))}
					</Form.Select>
				</Form.Group>
				<Col xs="auto">
					<Button variant="secondary" onClick={() => navigate(-1)}>
						Cancel
					</Button>
				</Col>
				<Col></Col>
				<Col xs="auto">
					<Button variant="primary" disabled={loading || !!error} onClick={download}>
						Download
					</Button>
				</Col>
			</Row>
		</Container>
	)
}

export default ScriptsPage

interface PropertiesOutput {
	properties: Property[]
}

interface TemplatesOutput {
	configScriptTemplates: ConfigScriptTemplate[]
}
